import { ChangeDetectionStrategy, Component, effect, model } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { FormField } from '@at/shared';

@Component({
  selector: 'at-members-filter',
  standalone: true,
  imports: [FormField, ReactiveFormsModule],
  templateUrl: './members-filter.component.html',
  styleUrl: './members-filter.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MembersFilterComponent {
  protected searchForm = new FormGroup({
    search: new FormControl('', { nonNullable: true }),
  });

  protected filterMembers(): void {
    this.filter.set(this.searchForm.value.search);
  }

  constructor() {
    effect(() => {
      const filter = this.filter();
      if (!filter) this.searchForm.reset();
    });
  }

  public filter = model<string | undefined>();

  public clearFilter(): void {
    this.filter.set(undefined);
  }
}
